
const data = [{
  id: 1,
  'catogery ': 'frute',
  color: 'Teal',
  type: 'The Pop Shoppe Pinapple',
  weight: 3,
}, {
  id: 2,
  'catogery ': 'sweet',
  color: 'Mauv',
  type: 'Chocolate - White',
  weight: 4,
}, {
  id: 3,
  'catogery ': 'electronic',
  color: 'Violet',
  type: 'Beer - Upper Canada Light',
  weight: 8,
}, {
  id: 4,
  'catogery ': 'food',
  color: 'Mauv',
  type: 'Snapple Raspberry Tea',
  weight: 4,
}, {
  id: 5,
  'catogery ': 'drink',
  color: 'Green',
  type: 'Wine - Ruffino Chianti',
  weight: 7,
}, {
  id: 6,
  'catogery ': 'frute',
  color: 'Indigo',
  type: 'Napkin - Cocktail,beige 2 - Ply',
  weight: 3,
}, {
  id: 7,
  'catogery ': 'frute',
  color: 'Puce',
  type: 'Cognac - Courvaisier',
  weight: 7,
}, {
  id: 8,
  'catogery ': 'sweet',
  color: 'Puce',
  type: 'Fond - Chocolate',
  weight: 8,
}, {
  id: 9,
  'catogery ': 'food',
  color: 'Puce',
  type: 'Tea - English Breakfast',
  weight: 3,
}, {
  id: 10,
  'catogery ': 'drink',
  color: 'Indigo',
  type: 'Iced Tea - Lemon, 340ml',
  weight: 7,
}, {
  id: 11,
  'catogery ': 'drink',
  color: 'Indigo',
  type: 'Beans - Kidney, Canned',
  weight: 1,
}, {
  id: 12,
  'catogery ': 'food',
  color: 'Purple',
  type: 'Bag - Bread, White, Plain',
  weight: 6,
}, {
  id: 13,
  'catogery ': 'Marlite Panels (FED)',
  color: 'Yellow',
  type: 'Milk - 1%',
  weight: 8,
}, {
  id: 14,
  'catogery ': 'Roofing (Metal)',
  color: 'Turquoise',
  type: 'Oil - Macadamia',
  weight: 7,
}, {
  id: 15,
  'catogery ': 'Construction Clean and Final Clean',
  color: 'Crimson',
  type: 'Filo Dough',
  weight: 2,
}, {
  id: 16,
  'catogery ': 'Overhead Doors',
  color: 'Mauv',
  type: 'Yogurt - Raspberry, 175 Gr',
  weight: 1,
}, {
  id: 17,
  'catogery ': 'Framing (Wood)',
  color: 'Puce',
  type: 'Extract - Rum',
  weight: 10,
}, {
  id: 18,
  'catogery ': 'Masonry & Precast',
  color: 'Goldenrod',
  type: 'Flour - Corn, Fine',
  weight: 10,
}, {
  id: 19,
  'catogery ': 'Marlite Panels (FED)',
  color: 'Goldenrod',
  type: 'Potato - Sweet',
  weight: 8,
}, {
  id: 20,
  'catogery ': 'Temp Fencing, Decorative Fencing and Gates',
  color: 'Khaki',
  type: 'Vinegar - Rice',
  weight: 6,
}];
export default data;
